var _excluded = ["searchAutocompleteUrlBase", "browseUrlFormat"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import deobfuscateString from '@domain-group/fe-allhomes-library/lib/utils/deobfuscate-string';
import MobileContainer from './mobile/container';
import DesktopContainer from './desktop/container';
import CommonPropTypes from '../models/common-prop-types';
import ContainerPropTypes from '../models/container-prop-types';
import * as styles from './allhomes-search-frontpage.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesSearchFrontpage = props => {
  var _props$media = props.media,
    mobile = _props$media.mobile,
    tablet = _props$media.tablet,
    desktop = _props$media.desktop;
  var searchAutocompleteUrlBase = props.searchAutocompleteUrlBase,
    browseUrlFormat = props.browseUrlFormat,
    finalProps = _objectWithoutProperties(props, _excluded);
  searchAutocompleteUrlBase = deobfuscateString(searchAutocompleteUrlBase);
  browseUrlFormat = deobfuscateString(browseUrlFormat);
  finalProps = _objectSpread(_objectSpread({
    searchAutocompleteUrlBase,
    browseUrlFormat
  }, finalProps), {}, {
    desktop
  });
  return ___EmotionJSX("div", {
    css: styles.frontpage
  }, mobile && ___EmotionJSX(MobileContainer, finalProps), (tablet || desktop) && ___EmotionJSX(DesktopContainer, finalProps));
};
AllhomesSearchFrontpage.propTypes = _objectSpread(_objectSpread(_objectSpread({}, CommonPropTypes), ContainerPropTypes), {}, {
  hero: PropTypes.shape()
});

/* eslint-disable react/default-props-match-prop-types */
AllhomesSearchFrontpage.defaultProps = {
  browseUrlFormat: '//www.allhomes.com.au/ah/%state/sale-residential',
  media: {},
  hero: undefined
};
export default withMedia(AllhomesSearchFrontpage);
export { AllhomesSearchFrontpage as BaseAllhomesSearchFrontpage };